// Adds a My Library item to a Piece's references as "cited" when the user
// explicitly quotes or cites it inside that Piece (drop or insert). This is a
// per-Piece user action, not an automatic bibliography rule.
import { supabase } from "@/integrations/supabase/client";

export async function attachSourceToPiece(
  workspaceId: string,
  pieceId: string,
  libraryItemId: string,
  label: string,
): Promise<void> {
  const { data: existing, error: readError } = await supabase
    .from("content_piece_references")
    .select("id, cited")
    .eq("workspace_id", workspaceId)
    .eq("piece_id", pieceId)
    .eq("reference_type", "source")
    .eq("reference_id", libraryItemId)
    .maybeSingle();
  if (readError) throw readError;
  const row = existing as { id: string; cited: boolean | null } | null;
  if (!row) {
    const { error } = await supabase.from("content_piece_references").insert({
      workspace_id: workspaceId,
      piece_id: pieceId,
      reference_type: "source",
      reference_id: libraryItemId,
      label_snapshot: label || "Source",
      sort_order: 0,
      cited: true,
    });
    if (error) throw error;
  } else if (row.cited === false) {
    const { error } = await supabase
      .from("content_piece_references")
      .update({ cited: true })
      .eq("workspace_id", workspaceId)
      .eq("id", row.id);
    if (error) throw error;
  }
}
